import { useGetCurrentUserQuery } from '../../../store/api/api';

export function AuthUserAva() {
  const { data: user } = useGetCurrentUserQuery();

  return (
    <div className="grid place-items-center gap-3 p-1">
      <img
        src={user.avatar}
        alt={user.name}
        className="h-8 w-8 rounded-full object-cover shadow-sm shadow-gray-500 hover:shadow-md"
      />
    </div>
  );
}

export function AuthUserInfo() {
  const { data: user } = useGetCurrentUserQuery();

  return (
    <>
      <p className="h-6 overflow-hidden text-ellipsis font-medium [word-break:break-word]">
        {user.name}
      </p>
      <p className="h-4 overflow-hidden text-ellipsis text-xs italic [word-break:break-word]">
        Super Admin
      </p>
    </>
  );
}
